export const sponsorablePropertyLocation = ({ city, state }) =>
  city && state ? `${city}, ${state}` : city || state;

export const ageRange = ({ maxAge, minAge }) => `${minAge}-${maxAge}`;

export const hasValidGeoData = ({ playLocation }) =>
  !!playLocation && !!playLocation.lat && !!playLocation.lon;
